import React from 'react';
import { Button, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExternalProvider } from '../hooks/use-external-providers';

interface ExternalProvidersProps {
  providers: ExternalProvider[];
  loading: boolean;
  tcAccepted: boolean;
  returnUrl: string;
  role?: string;
  setLoading: (loading: boolean) => void;
}

const ExternalProviders: React.FC<ExternalProvidersProps> = ({ providers, loading, tcAccepted, returnUrl, role, setLoading }) => {
  const { t } = useTranslation();

  if (providers.length === 0) return null;

  return (
    <>
      <Divider plain style={{ marginTop: 36, marginBottom: 13, color: tcAccepted ? undefined : '#00000040' }}>
        {t('o continúa con')}
      </Divider>
      <Row gutter={[16, 16]} justify="center" style={{ display: 'flex', rowGap: 16, columnGap: 16 }}>
        {providers.map(({ displayName, authenticationScheme }) => {
          const providerUrl = `${window.REACT_APP_API_BASE_URI}/external/ExternalRegister?scheme=${encodeURIComponent(
            authenticationScheme
          )}&returnUrl=${encodeURIComponent(returnUrl)}&role=${encodeURIComponent(role || '')}&termsAccepted=${tcAccepted ? 'true' : 'false'}`;
          return (
            <div key={`${displayName}_${authenticationScheme}`} style={{ display: 'flex', textAlign: 'center' }}>
              {/* La navegacion va en onClick y no se deja al href. antd 6 le quita el href al ancla
                cuando el boton esta disabled (button.js: href: mergedDisabled ? undefined : ...), y antd 5
                no lo hacia. Como el propio onClick marca el estado que deshabilita el boton, React
                re-renderiza antes de que el navegador evalue la navegacion por defecto, no encuentra href
                y no navega: el spinner se queda para siempre. El href se conserva para accesibilidad y
                para abrir en pestana nueva. */}
              <Button
                disabled={loading || !tcAccepted}
                href={providerUrl}
                ghost
                type="default"
                shape="round"
                style={
                  !loading && tcAccepted
                    ? { borderColor: '#D9D9D9', color: 'black', minWidth: 114 }
                    : { borderColor: '#D9D9D9', color: '#00000040', minWidth: 114 }
                }
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  window.location.assign(providerUrl);
                }}
              >
                {displayName}
              </Button>
            </div>
          );
        })}
      </Row>
    </>
  );
};

export default ExternalProviders;
